import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { Button } from "./Button.js";
const IconButton = React.forwardRef(function IconButton2({ variant = "ghost", className, children, ...rest }, ref) {
  return /* @__PURE__ */ jsx(Button, { ref, variant, className: cx("ev-btn--icon", className), ...rest, children: /* @__PURE__ */ jsx("span", { className: "ev-btn__icon", "aria-hidden": "true", children }) });
});
IconButton.displayName = "IconButton";
export {
  IconButton
};
//# sourceMappingURL=IconButton.js.map
